import styled from '@emotion/styled';
import { N20 } from '@atlaskit/theme/colors';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export var AvatarWrapper = styled.div({
  marginRight: "var(--ds-space-100, 8px)"
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export var AvatarCircleSkeleton = styled.div(function (props) {
  var _props$bgColor;
  return {
    backgroundColor: (_props$bgColor = props.bgColor) !== null && _props$bgColor !== void 0 ? _props$bgColor : "var(--ds-background-neutral, ".concat(N20, ")"),
    borderRadius: '50%',
    color: "var(--ds-text-inverse, white)",
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: "var(--ds-space-025, 2px)",
    width: props.size,
    height: props.size,
    '& svg': {
      width: props.size,
      height: props.size
    }
  };
});